import { Link } from 'react-router-dom';

const pillars = [
  {
    icon: 'ri-price-tag-3-line',
    title: 'Transparent Pricing',
    body: 'The price you see is the price you pay. No "market adjustment." No $800 mystery charges at signing. Just real numbers, upfront.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Broker Model',
    body: 'A broker works for you — not the bank, not the dealership. No rate markup. No commission on add-ons you don\'t need.',
  },
  {
    icon: 'ri-heart-line',
    title: 'The Dog Rescue Commitment',
    body: 'Three dogs. A genuine belief that shelters are prisons for animals that did nothing wrong. $100 per sale. Not a marketing strategy.',
  },
];

export default function OwnerPhilosophyStrip() {
  return (
    <section
      className="py-14 md:py-20 bg-[#1A2332]"
      aria-labelledby="owner-philosophy-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header row */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 bg-[#F5C842]/10 border border-[#F5C842]/25 text-[#F5C842] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
                <i className="ri-user-smile-line"></i>
              </span>
              Straight From the Owner
            </span>
            <h2
              id="owner-philosophy-heading"
              className="text-3xl md:text-4xl font-black text-white leading-tight"
              style={{ fontFamily: 'Oswald, sans-serif' }}
            >
              "I Got Tired of Watching<br className="hidden sm:block" />
              People Get Taken Advantage Of."
            </h2>
          </div>
          <p className="text-white/60 text-sm max-w-sm leading-relaxed lg:text-right hidden sm:block">
            No resume. No mission statement. Just the actual philosophy behind how this business runs — and why it doesn't look like a normal car dealership.
          </p>
        </div>

        {/* Pillars grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {pillars.map((p, i) => (
            <article
              key={i}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/8 hover:border-[#F5C842]/30 transition-all duration-300 group"
            >
              <div
                className="w-11 h-11 flex items-center justify-center rounded-xl mb-4 group-hover:scale-110 transition-transform"
                style={{ background: 'rgba(245,200,66,0.15)' }}
                aria-hidden="true"
              >
                <i className={`${p.icon} text-[#F5C842] text-xl`}></i>
              </div>
              <h3
                className="text-white font-bold text-base mb-2"
                style={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '0.04em' }}
              >
                {p.title}
              </h3>
              <p className="text-white/65 text-sm leading-relaxed">{p.body}</p>
            </article>
          ))}
        </div>

        {/* Pull quote + CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 bg-white/5 border border-white/10 rounded-2xl px-7 py-6">
          <blockquote className="flex-1">
            <p className="text-white/80 text-sm leading-relaxed italic">
              "The transparency costs me money. The dog rescue costs me money. The broker model makes less per transaction than a traditional dealership. But I can look at myself in the mirror."
            </p>
            <footer className="mt-2 text-[#F5C842] text-xs font-bold uppercase tracking-widest">
              — The Owner, Rockhound Auto
            </footer>
          </blockquote>
          <Link
            to="/about-the-owner"
            className="flex-shrink-0 inline-flex items-center gap-2 px-6 py-3 rounded-xl font-black text-sm text-[#1A2332] hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
            style={{ background: '#F5C842', fontFamily: 'Oswald, sans-serif', letterSpacing: '0.06em' }}
          >
            <i className="ri-user-smile-line" aria-hidden="true"></i>
            READ THE FULL STORY
          </Link>
        </div>

      </div>
    </section>
  );
}
